import type {
  Candidato,
  LoginRequest,
  ApiResponse,
  LoginResponse,
} from "../../../types";
import { AxiosResponse } from "axios";
import axiosInstance from "../../api/axiosConfig";
import { getApiBaseUrl } from "../../baseUrl";

const PATH_V1_CANDIDATO = "/candidatos";

export async function cadastrarCandidato(request: Candidato): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.post(`${apiUrl}${PATH_V1_CANDIDATO}`, request);
}

export async function listarCandidatos(): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.get(`${apiUrl}${PATH_V1_CANDIDATO}`);
}

export async function excluirCandidato(id: number): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.delete(`${apiUrl}${PATH_V1_CANDIDATO}/${id}`);
}

export async function atualizarCandidato(
  id: number,
  request: Partial<Candidato>,
): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.put(
    `${apiUrl}${PATH_V1_CANDIDATO}/${id}`,
    request,
  );
}

export async function inativarCandidato(id: number): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.patch(
    `${apiUrl}${PATH_V1_CANDIDATO}/${id}/inativar`,
  );
}

export async function ativarCandidato(id: number): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.patch(
    `${apiUrl}${PATH_V1_CANDIDATO}/${id}/ativar`,
  );
}

export async function buscarCandidatoPorId(id: number): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.get(`${apiUrl}${PATH_V1_CANDIDATO}/${id}`);
}

export async function loginCandidato(
  loginData: LoginRequest,
): Promise<AxiosResponse<ApiResponse<LoginResponse>>> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.post<ApiResponse<LoginResponse>>(
    `${apiUrl}${PATH_V1_CANDIDATO}/login`,
    loginData,
  );
}

export async function recuperarSenhaCandidato(recuperarData: {
  cpf: string;
  telefone: string;
  email: string;
}): Promise<any> {
  const apiUrl = getApiBaseUrl();
  return await axiosInstance.post(
    `${apiUrl}${PATH_V1_CANDIDATO}/recuperar-senha`,
    recuperarData,
  );
}
